/* import __COLOCATED_TEMPLATE__ from './email-template-help-modal.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class EmailTemplateHelpModal extends Component {
  @service modalService;
  @action
  closeModal() {
    this.modalService.closeModal();
  }
}
